import type { VAxios } from '../../define/axios/Axios';

export const createApi = (defHttp: VAxios) => ({
  removeText: (params: { imageUrl: string }) => {
    return defHttp.post({
      url: `/aiad/demo/remove-text`,
      params,
    });
  },
});
